import { Form } from './form';
import { Config } from '../config';
import { CountdownView } from '../view/countdown-view';
import { Order } from '../config/order';
import { Translations } from '../config/translations';
import { HubspotProvider } from '../providers/hubspot-provider';
import { Util } from '../config/utils';
import { Widget } from '../widgets/widget';
import { FormTypes } from './form-types';
import {Product} from '../config/product';
import {ProductType} from '../config/product-type';

export class CountdownForm extends Form {

    private static IS_RESPONSE_PENDING = false;

    provider: HubspotProvider = new HubspotProvider();
    view: CountdownView = new CountdownView();
    type = FormTypes.CountdownTimer;
    currentProduct: any = {};

    contact = {properties: {email:''}};

    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);
        const contactId = Util.getUrlParameter('dfc', window.location.href);

        if (this.config.products) {
            const products = this.config.products.filter((product: Product) => {
                return (product.type === ProductType.SINGLE_PAYMENT)
                    && !product.addon;
            });

            this.currentProduct = products[0] || {};
        }

        if(contactId){
            this.provider.getContactById(this.config.user.portalId, contactId, ['df_timer_started', 'email'])
                .then((response) => {

                    this.contact = response;

                    if(response.properties.df_timer_started){
                            this.startDelayedTimer(response.properties.df_timer_started, this.config.settings.countdown.seconds);
                        }else{
                            this.startTimer(this.config.settings.countdown.seconds);
                        }

                        return Promise.resolve();
                    }
                ).catch((error) => {
                return Promise.resolve();
            });
        }else{
            this.startTimer(this.config.settings.countdown.seconds);
        }
    }

    getProviderConfig() {
        return {
            host: process.env.API_URL,
            portalId: this.config.user.portalId
        };
    }

    async render() {
        this.view.render();
        return Promise.resolve();
    }

    isResponsePending = (): boolean => {
        return CountdownForm.IS_RESPONSE_PENDING;
    }

    startDelayedTimer(startDate: string, duration: number) {

        const startTimestamp = Date.parse(startDate);
        const leftDuration = duration - Math.round((new Date().getTime() - startTimestamp)/1000);

        this.startTimer(leftDuration);
    }

    startTimer(duration: number) {

        let seconds = duration;

        const countdownTimer = setInterval(() => {

            if (seconds <= 0) {
                clearInterval(countdownTimer);
                this.view.setTimerDescription(Translations.COUNTDOWN_OVER);
                this.timeOver();
                seconds = 0;
            } else {
                seconds--;
            }

            const hours       = Math.floor(seconds/60/60);
            const minutesLeft = Math.floor((seconds) - (hours * 3600));
            const minutes     = Math.floor(minutesLeft/60);
            const remainingSeconds = seconds % 60;

            const pad = (n: number) => (n < 10 ? '0' + n : n);
            this.view.setTimerValue(`<span>${pad(hours)}</span><span>${pad(minutes)}</span><span>${pad(remainingSeconds)}</span>`);

        }, 1000);

        this.view.startPulsating();
    }

    timeOver(){

        if(this.config.settings.countdown.finalCallback){
            this.config.settings.countdown.finalCallback();
        }

        if(this.config.settings.countdown.finalPrice){
            this.paymentData.amount = this.config.settings.countdown.finalPrice - this.currentProduct.amount;
            this.currentProduct.amount = this.config.settings.countdown.finalPrice;

            this.triggerEvent('amountChange');
        }
    }

    getElementValue(selector: string) {
        const htmlElement = (this.view.getFromHSFrame(selector) ||
            this.view.getHtmlElement(selector)) as HTMLInputElement;
        return htmlElement ? htmlElement.value : null;
    }

    setEmailValue(widget: Widget){
        if(this.contact.properties.email){
            widget.getHubSpotForm().setFieldValue('email', this.contact.properties.email);
            this.view.getInputElement('[name=email]').disabled = true;
        }
    }

    setElementValue(selector: string, value: string){
        const htmlElement = (this.view.getFromHSFrame(selector) ||
            this.view.getHtmlElement(selector)) as HTMLInputElement;

        if (htmlElement) {
            htmlElement.value = value;
            htmlElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    submit(order: Order) {
        return Promise.resolve(order);
    }


}
